<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The Palmer Drought Severity Index (PDSI) is a simple water balance model originally designed by Palmer under the framework of water balance between water supply and atmospheric evaporative demand. In brief, the PDSI drought is estimated by the difference between the monthly precipitation, potential evaporation and some other parameters. Historical and future characteristics of climate change impacts are analyzed using 21 ensemble runs (GCMs) in CMIP5 (Coupled Model Intercomparison Project phase 5): GFDL-ESM2M, HadGEM2-ES, IPSL-CM5A-LR, MIROC-ESM-CHEM, NorESM1-M, CNRM-CM5, CanESM2, GFDL-CM3, GFDL-ESM2G, MIROC-ESM, MIROC5, and MRI-CGCM3) under three representative concentration pathways (RCPs) are considered, i.e., Rcp4.5 and Rcp8.5. Meanwhile, 13 GCMs (due to limited data sources) under Rcp2.6 scenarios are analyzed. Here we use PDSI, which takes precipitation (P), evapotranspiration (ET0), and available water storage capacity as input to compute a water balance, in global drought estimation to simulate GDP exposure to drought. The calculation of PDSI are as follows,
        </el-row>
        <el-row style="text-align: right;">
          <img src="http://bunjs.aiside.top/3-1.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The precipitation, max temperature and min temperature in 21 GCMs for both historical period (1986-2005) and future of 2030s (2016-2035 under Rcp2.6, Rcp4.5 and Rcp8.5 scenarios) and 2050s (2046-2065 under Rcp2.6, Rcp4.5 and Rcp8.5 scenarios) were obtained in PDSI calculation. Then the GDP exposure to drought is the total GDP in each pixel exposed to mild, moderate, severe, and extreme droughts using GDP projections from SSP1-3.
        </el-row>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "GDPExposureToDrought"
  }
</script>

<style scoped>


  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GDPExposureToDrought.vue